var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container" }, [
          _c("div", { staticClass: "page-name" }, [_vm._v("New Users")]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary ml-1 pull-right",
              attrs: { type: "button", id: "exportUsers" },
              on: {
                click: function($event) {
                  return _vm.exportUsersData($event)
                }
              }
            },
            [_vm._v("\n                Export\n            ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary ml-1 pull-right",
              attrs: {
                type: "button",
                "data-toggle": "modal",
                "data-target": "#newUserImportModal"
              }
            },
            [_vm._v("\n                Import\n            ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary waves-effect pull-right",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.addBenefit.apply(null, arguments)
                }
              }
            },
            [_vm._v("Add")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c(
            "div",
            { staticClass: "app-filter-good-table-container" },
            [
              _c("vue-good-table", {
                ref: "notregisterUserList",
                attrs: {
                  mode: "remote",
                  title: "New User List",
                  totalRows: _vm.totalRecords,
                  columns: _vm.columns,
                  rows: _vm.rows,
                  "pagination-options": {
                    enabled: true,
                    mode: "pages",
                    pageLabel: "Page",
                    position: "bottom",
                    perPage: _vm.serverParams.perPage,
                    perPageDropdown: [25, 50, 100, 200, 500],
                    dropdownAllowAll: false
                  },
                  selectOptions: {
                    enabled: true,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: "custom-class",
                    selectionText: "rows selected",
                    clearSelectionText: "clear"
                  },
                  "search-options": {
                    enabled: false
                  }
                },
                on: {
                  "on-page-change": _vm.onPageChange,
                  "on-selected-rows-change": _vm.selectionChanged,
                  "on-column-filter": _vm.onColumnFilter,
                  "on-per-page-change": _vm.onPerPageChange,
                  "on-sort-change": _vm.onSortChange
                },
                scopedSlots: _vm._u(
                  [
                    _vm._l(_vm.rows, function(row, key) {
                      return {
                        key: "table-row",
                        fn: function(props) {
                          return [
                            _c("div", { key: key }, [
                              props.column.field == "action"
                                ? _c(
                                    "div",
                                    { staticClass: "table-action" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "btn edit-btn-vvg waves-effect",
                                          attrs: {
                                            title: "Edit User",
                                            to: {
                                              name: "UpdateNotRegisteredUser",
                                              params: { id: props.row.id }
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-pencil",
                                            attrs: { "aria-hidden": "true" }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "btn edit-btn-vvg waves-effect",
                                          attrs: {
                                            title: "Delete User",
                                            id: "delete"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.deleteSingleUser(
                                                props.row.id
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-trash",
                                            attrs: { "aria-hidden": "true" }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.loginUserId != props.row.id
                                        ? [
                                            props.row.is_active
                                              ? [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "btn edit-btn-vvg waves-effect",
                                                      attrs: {
                                                        title: "Make Deactive"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.changeActiveInactiveStatus(
                                                            props.row.id,
                                                            "Deactive"
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-eye-slash",
                                                        attrs: {
                                                          "aria-hidden": "true"
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              : [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "btn edit-btn-vvg waves-effect",
                                                      attrs: {
                                                        title: "Make Active"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.changeActiveInactiveStatus(
                                                            props.row.id,
                                                            "Active"
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-eye",
                                                        attrs: {
                                                          "aria-hidden": "true"
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                : _c("div", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          props.formattedRow[props.column.field]
                                        ) +
                                        "\n                            "
                                    )
                                  ])
                            ])
                          ]
                        }
                      }
                    }),
                    {
                      key: "selected-row-actions",
                      fn: function(computed) {
                        return _c("div", {}, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(computed.selectedRows) +
                              "\n                        "
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: {
                                "data-toggle": "modal",
                                id: "changeRoleModel",
                                title: "Change role",
                                "data-target": "#changeRole"
                              }
                            },
                            [_vm._v("Change Role")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: { id: "deleteMultiple" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.changeSelectedUserDetails(
                                    "deleteMultipleUsres"
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "Delete Users (" +
                                  _vm._s(_vm.selectedRows) +
                                  ")"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-success",
                              attrs: { title: "Make Active" },
                              on: {
                                click: function($event) {
                                  return _vm.changeActiveInactiveStatus(
                                    0,
                                    "Active"
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "Active (" + _vm._s(_vm.selectedRows) + ")"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-danger",
                              attrs: { title: "Make Deactive" },
                              on: {
                                click: function($event) {
                                  return _vm.changeActiveInactiveStatus(
                                    0,
                                    "Deactive"
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "Deactive (" + _vm._s(_vm.selectedRows) + ")"
                              )
                            ]
                          )
                        ])
                      }
                    }
                  ],
                  null,
                  true
                )
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "modal fade",
                  attrs: { id: "changeRole", role: "dialog" }
                },
                [
                  _c("div", { staticClass: "modal-dialog" }, [
                    _c("div", { staticClass: "modal-content" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("div", { staticClass: "modal-body" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { attrs: { for: "roleData" } }, [
                                _vm._v("Designation")
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-select",
                                {
                                  attrs: {
                                    name: "roleId",
                                    id: "roleId",
                                    label: "text",
                                    filterable: false,
                                    options: _vm.roleArr,
                                    placeholder: "Select Role"
                                  },
                                  on: {
                                    change: _vm.changedValue,
                                    input: function($event) {
                                      return _vm.changedValueRole()
                                    },
                                    search: _vm.onSearchRole
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "option",
                                      fn: function(option) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "d-center" },
                                            [
                                              _vm._v(
                                                "\n                                                    " +
                                                  _vm._s(option.text) +
                                                  "\n                                                "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "selected-option",
                                      fn: function(option) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "selected d-center"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                    " +
                                                  _vm._s(option.text) +
                                                  "\n                                                "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.roleId,
                                    callback: function($$v) {
                                      _vm.roleId = $$v
                                    },
                                    expression: "roleId"
                                  }
                                },
                                [
                                  _c("template", { slot: "no-options" }, [
                                    _vm._v(
                                      "\n                                                Search Role...\n                                            "
                                    )
                                  ])
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: {
                                "data-dismiss": "modal",
                                type: "submit"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.changeSelectedUserDetails(
                                    "change_role"
                                  )
                                }
                              }
                            },
                            [_vm._v("Save")]
                          )
                        ])
                      ])
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "modal fade",
                  attrs: { id: "changeLocation", role: "dialog" }
                },
                [
                  _c("div", { staticClass: "modal-dialog" }, [
                    _c("div", { staticClass: "modal-content" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("div", { staticClass: "modal-body" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { attrs: { for: "locationId" } }, [
                                _vm._v("State")
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-select",
                                {
                                  attrs: {
                                    name: "locationId",
                                    id: "locationId",
                                    label: "text",
                                    filterable: false,
                                    options: _vm.locationArr,
                                    placeholder: "Select State"
                                  },
                                  on: {
                                    change: _vm.changedValue,
                                    search: _vm.onSearchLocation
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "option",
                                      fn: function(option) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "d-center" },
                                            [
                                              _vm._v(
                                                "\n                                                    " +
                                                  _vm._s(option.text) +
                                                  "\n                                                "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "selected-option",
                                      fn: function(option) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "selected d-center"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                    " +
                                                  _vm._s(option.text) +
                                                  "\n                                                "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.locationId,
                                    callback: function($$v) {
                                      _vm.locationId = $$v
                                    },
                                    expression: "locationId"
                                  }
                                },
                                [
                                  _c("template", { slot: "no-options" }, [
                                    _vm._v(
                                      "\n                                                Search State...\n                                            "
                                    )
                                  ])
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: {
                                type: "submit",
                                "data-dismiss": "modal"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.changeSelectedUserDetails(
                                    "change_location"
                                  )
                                }
                              }
                            },
                            [_vm._v("Save")]
                          )
                        ])
                      ])
                    ])
                  ])
                ]
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: { id: "newUserImportModal", tabindex: "-1", role: "dialog" }
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog", attrs: { role: "document" } },
            [
              _c("div", { staticClass: "modal-content" }, [
                _vm._m(2),
                _vm._v(" "),
                _c(
                  "form",
                  {
                    staticClass: "form-inline",
                    attrs: {
                      id: "importTasksform",
                      enctype: "multipart/form-data"
                    }
                  },
                  [
                    _c("div", { staticClass: "modal-body" }, [
                      _vm._v(
                        "\n                        Select Excel File to Import New Users\n                        "
                      ),
                      _c("label", { staticClass: "myLabel btn btn-primary" }, [
                        _c("input", {
                          ref: "filesUserData",
                          staticStyle: { display: "none" },
                          attrs: {
                            type: "file",
                            name: "excl_file",
                            accept: ".xlsx,.xls",
                            id: "upload"
                          },
                          on: {
                            change: function($event) {
                              return _vm.handleFilesUploadCall()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Select File ...")])
                      ]),
                      _vm._v(" "),
                      _vm._m(3),
                      _vm._v(" "),
                      _vm._m(4),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" }),
                      _vm._v(" "),
                      _vm._m(5),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "row mt-3 col-lg-12 col-md-12 col-sm-12 col-xs-12"
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary mr-2",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.importUsersData($event)
                                }
                              }
                            },
                            [_vm._v("Import")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-danger waves-effect",
                              attrs: { type: "button", "data-dismiss": "modal" }
                            },
                            [_vm._v("Close")]
                          )
                        ]
                      )
                    ])
                  ]
                )
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h4",
        { staticClass: "modal-title", attrs: { id: "defaultModalLabel" } },
        [_vm._v("Change Designation")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h4",
        { staticClass: "modal-title", attrs: { id: "defaultModalLabel" } },
        [_vm._v("Change Location")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: { type: "button", "data-dismiss": "modal" }
        },
        [_vm._v("×")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h4",
        { staticClass: "modal-title", attrs: { id: "defaultModalLabel" } },
        [_vm._v("Import New Users Excel")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group" }, [
      _c("label", { staticClass: "error", attrs: { id: "errorMsg" } }),
      _c("br")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "clearfix" }, [
      _c(
        "a",
        {
          staticClass: "btn btn-primary",
          attrs: { id: "demourl", href: "demoUrl", target: "_blank" }
        },
        [
          _vm._v(
            "\n                                Download Demo\n                            "
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row clearfix" }, [
      _c("div", { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" }, [
        _c(
          "div",
          {
            staticClass: "mt-10 alert alert-danger",
            attrs: { id: "alertError" }
          },
          [
            _c("strong", {
              staticClass: "error",
              attrs: { id: "backErrorMsg" }
            })
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-995ac19e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-995ac19e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/notregisteredusers/ListNotRegisteredUser.vue
// module id = null
// module chunks = 